import { CONFIG } from '@config';
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from '@ovComponents/2-component/dialog/dialog';
import { UserContext } from '@providers/userContextProvider';
import {
  Box,
  IconButton,
  Typography,
  useSnackbar,
  useTheme,
} from 'hephaestus/web';
import { ChevronRight, Close as CloseIcon } from 'hephaestus/webIcons';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocalization } from '../../../hooks/useLocalization';

export const LoginSettingModal = ({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
}) => {
  const { translateBackendString } = useLocalization();
  const { t } = useTranslation(['components', 'shared']);
  const theme = useTheme();
  const { userContext, activeOrganization } = useContext(UserContext);
  const { enqueueSnackbar } = useSnackbar();

  const handleClose = () => setOpen(false);

  const resetPassword = async () => {
    try {
      const data = await fetch(
        new Request(
          `https://${CONFIG.auth.domain}/dbconnections/change_password`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              client_id: CONFIG.auth.clientId,
              email: userContext?.email,
              connection: 'Username-Password-Authentication',
            }),
          },
        ),
      );
      if (!data.ok) throw new Error(`${data.status} ${data.statusText}`);
      enqueueSnackbar(t('components:loginSettings.resetPasswordSuccess'), {
        variant: 'success',
      });
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          borderBottom: `1px ${theme.color.outlineVariant} solid`,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant='headingSmall'>
            {translateBackendString(activeOrganization.loginSettingsTitle)}
          </Typography>
        </Box>
        <IconButton aria-label='close' onClick={handleClose}>
          <CloseIcon fontSize='inherit' />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box
          onClick={() => {
            resetPassword();
            setOpen(false);
          }}
          sx={{
            my: 1.5,
            p: 2,
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            justifyContent: 'space-between',
            border: `1px ${theme.color.outlineVariant} solid`,
            borderRadius: theme.borderRadius.lg,
          }}
        >
          <Typography variant='titleMedium'>
            {t('components:loginSettings.changePassword')}
          </Typography>
          <ChevronRight />
        </Box>
      </DialogContent>
    </Dialog>
  );
};
